/*jshint esversion: 11 */

export function normalizeFilterBoolean(value) {
  if (value === true || value === 'true' || value === 1 || value === '1') return 'true';
  if (value === false || value === 'false' || value === 0 || value === '0') return 'false';
  return '';
}

export function buildChildListQueryParams(queryOptions = {}, sorting_option = '') {
  const options = queryOptions || {};

  return {
    filter_dob_start_date: options.filter_dob_start_date ?? '',
    filter_dob_end_date: options.filter_dob_end_date ?? '',
    filter_name: options.filter_name ?? '',
    filter_phone_number: options.filter_phone_number ?? '',
    filter_email_address: options.filter_email_address ?? '',
    filter_roll_no: options.filter_roll_no ?? '',
    filter_gender: options.filter_gender ?? '',
    filter_address_location: options.filter_address_location ?? '',
    filter_children: options.filter_children ?? '',
    filter_offering: options.filter_offering ?? '',
    include_deleted: options.include_deleted ?? '',
    include_profile_completed: options.include_profile_completed ?? '',
    filter_has_parent: normalizeFilterBoolean(options.filter_has_parent),
    filter_has_profile_picture: normalizeFilterBoolean(options.filter_has_profile_picture),
    sorting_option: sorting_option || options.sorting_option || ''
  };
}
